import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AccessModuleServiceService {

  constructor() { }

  private accessSubject = new BehaviorSubject<boolean>(true);
  private roleNameSubject = new BehaviorSubject<string>('');
  access$ = this.accessSubject.asObservable();
  roleName$ = this.roleNameSubject.asObservable();

  setAccess(hasAccess: boolean): void {
    this.accessSubject.next(hasAccess);
  }
  setRoleName(roleName: string): void {
    this.roleNameSubject.next(roleName);
  }
}
